import { forwardRef } from 'react';

import {
  ProductCarouselDesktop,
  ProductCarouselMobile,
} from '~/components/isolated/Carousel';
import ProductCardSkeletonFactory from '~/components/ProductCardV3/skeletons/ProductCardSkeletonFactory';
import { useGlobal } from '~/hooks/useGlobal';

import styles from './ProductsCarouselSliderOneBlock.module.scss';

const ProductsCarouselSliderOneBlockSkeleton = forwardRef<
  HTMLDivElement,
  { className?: string }
>(({ className }, ref) => {
  const { isMobile } = useGlobal();

  // Create skeleton items
  const skeletonComponent = (
    <div className={styles.skeletonContainer}>
      {Array.from({ length: 5 }, (_, i) => (
        <ProductCardSkeletonFactory key={`skeleton-${i}`} variant="m" />
      ))}
    </div>
  );

  const commonProps = {
    title: 'Loading...',
    items: [],
    skeletonComponent,
  };

  return (
    <div className={className} ref={ref}>
      <div className={styles.container}>
        {isMobile ? (
          <ProductCarouselMobile
            {...commonProps}
            itemClassName={styles.item}
            showViewAllOnMobile
          />
        ) : (
          <ProductCarouselDesktop
            {...commonProps}
            slideClassName={styles.slide}
            contentClassName={styles.carouselContent}
          />
        )}
      </div>
    </div>
  );
});

ProductsCarouselSliderOneBlockSkeleton.displayName =
  'ProductsCarouselSliderOneBlockSkeleton';

export default ProductsCarouselSliderOneBlockSkeleton;
